import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Pill from "../../common/Pill";
import styles from "./sell.module.scss";

interface Props {
  text?: string;
}

const SellOperation = ({ text }: Props) => {
  const { t } = useTranslation();

  return (
    <Pill
      styleName="sell"
      Lefticon={<img src="../../../assets/images/svg/sellIcon.svg" />}>
      <p className={classNames(styles.sellText, "p2")}>
        {text ? text : `${t("lbl_contract_operation_type_sell")}`}
      </p>
    </Pill>
  );
};

export default SellOperation;
